import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createRent: {
        method: 'POST',
        url: `${BASE_PATH_API}/rent`
    },
    getRents: {
        method: 'GET',
        url: `${BASE_PATH_API}/rent/:leaseId`
    },
    getRent: {
        method: 'GET',
        url: `${BASE_PATH_API}/rent/rents/:rentId`
    },
    deleteRent: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/rent/rents/:rentId`
    },
    editRent: {
        method: 'PUT',
        url: `${BASE_PATH_API}/rent/rents`
    },
    activateRent: {
        method: 'POST',
        url: `${BASE_PATH_API}/rent/activateRentCommand`
    },
    splitRent: {
        method: 'POST',
        url: `${BASE_PATH_API}/rent/splitRentCommand`
    },
};
export function RentApi() {
    return createActions(actions);
}
